// 旧ログイン方式（API経由）でローカルストレージに保存していた認証情報のキー
const STORAGE_KEY_AUTH_INFO = 'COLORFULLY_MANAGEMENT_AUTH';

export const removeAuthInfoFromStorage = (): void => {
  try {
    window.localStorage.removeItem(STORAGE_KEY_AUTH_INFO);
  } catch {
    // ストレージが使えない環境では何もしない
  }
};
